import { configureStore } from '@reduxjs/toolkit';
import formConfig from './slices/formconfig';


const store = configureStore({
  reducer: {
    formConfig: formConfig,
   
  },
});

export default store;